export const mapRole = (role, isAdmin) => {
    switch (role) {
      case 'regular':
      case 'admin':
      case 'broker:admin':
      case 'broker:regular':
        return isAdmin ? 'broker:admin' : 'broker:regular'
      case 'underwriter':
      case 'underwriter:admin':
        return isAdmin ? 'underwriter:admin' : 'underwriter:regular'
      default:
        return 'broker:regular'
    }
  }
